import Modal from 'components/Modal'
import GetUpdatesForm from 'components/forms/GetUpdatesForm'
import React, { useState } from 'react'
import AboutUsLogo from 'images/logo/IE-logo-2.png'


const TenthSection = () => {

    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
        document.body.style.overflow = "auto"
    };
    return (
        <div className='flex flex-col md:flex-row justify-between items-center gap-y-8'>
            <div className='font-bold w-2/3 text-base-100 text-2xl sm:text-3xl text-center md:text-left'>Subscribe To Receive Important Information & Updates Regarding Health Insurance</div>
            <button className='btn btn-lg btn-wide btn-base-100' onClick={() => { setOpen(true); document.body.style.overflow = "hidden" }}>Get Updates</button>

            {/* Mobile Form */}
            <Modal open={open} handleClose={handleClose}>
                <div className='flex justify-center pb-4'>

                    <div className='max-w-md space-y-12'>
                        <div className='space-y-4'>
                            <div className='flex justify-center'><img src={AboutUsLogo} alt='IE Logo' /></div>
                            <div className='text-4xl font-bold text-center'>Get Health Insurance Updates</div>
                        </div>
                        <GetUpdatesForm setOpen={setOpen} />
                        {/* <iframe
                            src="https://api.leadconnectorhq.com/widget/form/jehEyvwBY1KUb75Hvs2n"
                            style={{ width: "450px", height: "540px", border: "", borderRadius: "3px" }}
                            id="popup-jehEyvwBY1KUb75Hvs2n"
                            data-layout="{'id':'POPUP'}"
                            data-trigger-type="alwaysShow"
                            data-trigger-value=""
                            data-activation-type="alwaysActivated"
                            data-activation-value=""
                            data-deactivation-type="neverDeactivate"
                            data-deactivation-value=""
                            data-form-name="Get Updates"
                            data-height="455"
                            data-layout-iframe-id="popup-jehEyvwBY1KUb75Hvs2n"
                            data-form-id="jehEyvwBY1KUb75Hvs2n"
                            title="Get Updates"
                        >
                        </iframe> */}

                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default TenthSection